export default "__VITE_ASSET__BSae0R$p__"